const blocks = document.querySelectorAll(
  ".wp-block-adspire-ai-post-filter-navbar"
);

if (blocks.length) {
  import("./view-frontend.js").then(({ initBlock }) => {
    blocks.forEach((block) => initBlock(block));
  });
}
